import { WorkExperienceData } from "./types";

/**
 * Normalizes the work_experience field which can be a string (legacy years),
 * an array (legacy experience list), or the new object structure.
 */
export function normalizeWorkExperience(data: any): WorkExperienceData {
  // Default empty structure
  const empty: WorkExperienceData = {
    entries: [],
    areas_of_expertise: ""
  };

  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return empty;
  }

  // Strict check: only accept object structure
  return {
    entries: Array.isArray(data.entries) ? data.entries : [],
    areas_of_expertise:
      typeof data.areas_of_expertise === "string" ? data.areas_of_expertise : ""
  };
}

/**
 * Normalizes the education field.
 */
import { EducationData } from "./types";

export function normalizeEducation(data: any): EducationData {
  const empty: EducationData = {
    entries: []
  };

  if (!data) return empty;

  // New object structure
  if (
    typeof data === "object" &&
    !Array.isArray(data) &&
    Array.isArray(data.entries)
  ) {
    return {
      entries: data.entries
    };
  }

  // Direct array structure support
  if (Array.isArray(data)) {
    return { entries: data };
  }

  return empty;
}
